import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { GanttButtonComponent } from '../gantt-button/gantt-button.component';

@Component({
    selector: 'tt-gantt-toggle',
    standalone: false,
    templateUrl: './gantt-toggle.component.html',
    styleUrls: ['../gantt-button/gantt-button.component.css', './gantt-toggle.component.css'],
})
export class GanttToggleComponent extends GanttButtonComponent {
    @Input()
    public get ttModel(): boolean { return this._model; }
    public set ttModel(value: BooleanInput) { this._model = coerceBooleanProperty(value); }
    private _model = false;

    @Output() public ttModelChange = new EventEmitter<boolean>();

    public override click(event: MouseEvent): void {
        if (this.ttDisabled || this.ttLoading) return;
        this.ttModel = !this.ttModel;
        this.ttModelChange.emit(this.ttModel);
        super.click(event);
    }
}
